import { DefaultContext, mutationPromise } from '@egw/clients'
import {
  EnrollmentJointDeclineSubmitInput,
  EnrollmentJointDeclineSubmitOutput,
} from '../../../../models/enrollment/joint/decline'
import { createMutationHook } from '../../../../hooks'

export const submitEnrollmentJointDeclineData = async (
  enrollmentJointDeclineSubmitInput: EnrollmentJointDeclineSubmitInput,
  context?: DefaultContext,
): Promise<EnrollmentJointDeclineSubmitOutput> => {
  const response = (await mutationPromise(
    {
      name: 'submitEnrollmentJointDeclineData',
      query: `mutation submitEnrollmentJointDeclineData($input: SubmitJointEnrollmentInput!) {
      submitJointEnrollment(input: $input) {
        errors
        isError
        activePerson {
          path
        }
      }
    }`,
    },
    {
      input: enrollmentJointDeclineSubmitInput,
    },
    context,
  )) as { submitJointEnrollment: EnrollmentJointDeclineSubmitOutput }
  return response.submitJointEnrollment
}

export const useSubmitEnrollmentJointDeclineData = createMutationHook<
  EnrollmentJointDeclineSubmitInput,
  EnrollmentJointDeclineSubmitOutput
>(submitEnrollmentJointDeclineData)
